import { AutocompleteRenderInputParams, Flag, InputAdornment, TextField, TextFieldProps } from '@internations/ds'
import { ForwardedRef, forwardRef, ReactElement } from 'react'

type Props = {
    iocCode: TIocCode | null
    error?: string | boolean
    textFieldProps: AutocompleteRenderInputParams
} & Pick<TextFieldProps, 'onFocus' | 'onBlur' | 'label' | 'placeholder'>

/**
 * The input field used by `<CitySelector>`. It is mostly used to define how the field should display. It does not include most of the functionality of the main `<CitySelector>`, e.g. suggestions. You probably don't want to use this component directly, but instead use `<CitySelector>` or `<FormikCitySelector>`.
 */
export const CitySelectorText = forwardRef(function CS(
    { iocCode, label, error, textFieldProps, onBlur, onFocus }: Props,
    ref: ForwardedRef<HTMLDivElement>
): ReactElement {
    const inputProps = {
        ...textFieldProps.InputProps,
    }

    if (iocCode) {
        inputProps.startAdornment = (
            <InputAdornment position="start">
                <Flag code={iocCode} data-testid="flag" />
            </InputAdornment>
        )
    }

    return (
        <TextField
            onFocus={onFocus}
            onBlur={onBlur}
            variant="outlined"
            slotProps={{
                input: inputProps,
            }}
            error={Boolean(error)}
            helperText={error}
            label={label}
            {...textFieldProps}
            ref={ref}
        />
    )
})
